import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class ScrollToTop extends React.Component {
  static propTypes = {
    location: PropTypes.shape().isRequired,
    children: PropTypes.element.isRequired,
    clearError: PropTypes.func.isRequired,
    error: PropTypes.shape().isRequired,
  };

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      if (this.props.error.id) this.props.clearError();
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

const mapState = state => ({
  error: state.error,
});

const mapDispatch = dispatch => ({
  clearError: () => dispatch({ type: 'CLEAR_ERROR' }),
});

export default withRouter(connect(mapState, mapDispatch)(ScrollToTop));



// WEBPACK FOOTER //
// ./src/components/ScrollToTop.js